import { Link } from "react-router-dom"
import { Route } from "lucide-react"

type ProgramEntry = {
  program: { id: string; name: string; slug: string }
}

type RelatedLearningPathsSectionProps = {
  programs?: ProgramEntry[]
}

export default function RelatedLearningPathsSection({ programs }: RelatedLearningPathsSectionProps) {
  if (!programs || programs.length === 0) return null

  return (
    <section>
      <h2 className="text-2xl font-semibold text-foreground tracking-tight mb-6">
        Este curso es parte de estas rutas de aprendizaje
      </h2>
      <div className="grid gap-4 sm:grid-cols-2">
        {programs.map(({ program }) => (
          <Link
            key={program.id}
            to={`/programs/${program.slug}`}
            className="group flex items-center gap-4 rounded-xl border border-border bg-foreground/[0.02] p-5 transition-colors hover:bg-foreground/[0.05] hover:border-primary/30"
          >
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
              <Route className="h-5 w-5" />
            </div>
            <p className="min-w-0 flex-1 font-semibold text-foreground truncate">{program.name}</p>
          </Link>
        ))}
      </div>
    </section>
  )
}
